/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Kick_MembersInputs */



/**
* | output |
* | --- |
* | "Kick, Approve and Reject Members" |
*
* @param {Leveling_Perm_Kick_MembersInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_kick_members = /** @type {((inputs?: Leveling_Perm_Kick_MembersInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Kick_MembersInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выгонять, одобрять и отклонять участников")
	return /** @type {LocalizedString} */ ("Kick, Approve and Reject Members")
});